import React from 'react'
import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import useAuth from '../../Hooks/useAuth';

const Register = () => {
  const {showDummyImage} = useAuth()
  return (
    <section className="login">
      <div className="container">
        <div className="login-wrapper">
          <div className="login-left">
            <div className="login-left-img">
              <img src={require("../../assets/images/login/login.png")} alt={'register'} onError={({ currentTarget },imageSize = "520X570") => showDummyImage({ currentTarget }, imageSize)} />
            </div>
          </div>
          <div className="login-right">
            <div className="login-content">
              <h2>Get’s Started.</h2>
              <p>
                New Account Get Register?
                <Link to={"/signin"} className="register">
                  Sign In
                </Link>
              </p>
            </div>
            <form className="login-form">
              <div className="login-input">
                <input type="text" placeholder="Type User name" />
                 <div className="login-input-icon-container"> <FaUser className="login-input-icon" /></div>
              </div>
              <div className="login-input">
                <input type="email" placeholder="Email" />
                <div className="login-input-icon-container"> <MdEmail className="login-input-icon" /></div>
              </div>
              <div className="login-input">
                <input type="password" placeholder="Password" />
                 <div className="login-input-icon-container"> <RiLockPasswordFill className="login-input-icon" /></div>
              </div>
              <input
                type="submit"
                value="LogIn Your Account"
                className="login-submit"
              />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Register